import { render, staticRenderFns } from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=template&id=2285e599&scoped=true&"
import script from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellSummaryItemsV3.vue?vue&type=style&index=0&id=2285e599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285e599",
  null
  
)

export default component.exports